if (typeof window !== "undefined") {
  if (window.jQuery && !window.$) {
    window.$ = window.jQuery;
  }
}

export default (typeof window !== "undefined" ? window.jQuery || window.$ : null);
